import { render, staticRenderFns } from "./SalaryRespondedAt.vue?vue&type=template&id=56f607ce&scoped=true"
import script from "./SalaryRespondedAt.vue?vue&type=script&lang=js"
export * from "./SalaryRespondedAt.vue?vue&type=script&lang=js"
import style0 from "./SalaryRespondedAt.vue?vue&type=style&index=0&id=56f607ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f607ce",
  null
  
)

export default component.exports